import React, { useState } from "react";

import { Example, Compare } from "../../example";
import { FixedInputValue } from "./component";

export default function NumberFormatDemo() {
  return (
    <Example
      title="Fixed input value"
      desc={
        <>
          <p>
            Users should to type confirmation text? Don't let them fail. Create
            input which accepts only fixed value and shows rest.
          </p>
          <p>
            This field accepts only "I agree with terms and conditions" as input
            value.
          </p>
        </>
      }
      filepath="/src/examples/FixedInputValue/component.js"
      demo={Demo}
    />
  );
}

function Demo() {
  const [value, setValue] = useState("I agree");

  return (
    <Compare>
      <Compare.Group title={<code>{"<input>"}</code>}>
        <label>
          <span className="exampleBlock-label">Confirmation</span>
          <input
            className="regularInput"
            value={value}
            onChange={e => {
              setValue(e.target.value);
            }}
          />
        </label>
      </Compare.Group>
      <Compare.Group title={<code>{"<MightyInput>"}</code>}>
        <label>
          <span className="exampleBlock-label">Confirmation</span>
          <FixedInputValue
            value={value}
            onlyValue={"I agree with terms and conditions"}
            onUpdate={next => setValue(next)}
          />
        </label>
      </Compare.Group>
    </Compare>
  );
}
